import type { Emulator } from '@/types/emulator'

export interface DeveloperPanelState {
  emulators: Emulator[]
}

export enum DEVELOPER_PANEL_MUTATIONS {
  ADD_EMULATOR = 'addEmulator',
  SET_EMULATORS = 'setEmulators',
}

export enum DEVELOPER_PANEL_ACTIONS {
  ADD_EMULATOR = 'addEmulator',
  SET_EMULATORS = 'setEmulators',
}

export enum DEVELOPER_PANEL_GETTERS {
  GET_EMULATORS = 'getEmulators',
}
